module.exports = __webpack_public_path__ + "static/media/shipContent.657e6a3a.jpg";